import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  PromotionMessageModel,
  PromotionMessageWizardModel
} from '../../../../models/promotion-message.model';
import {MenuItem} from 'primeng/components/common/api';
import {TranslateService} from '@ngx-translate/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PromotionWizardService} from '../../../../services/promotion/promotion-wizard.service';
import {PromotionMessageService} from '../../../../services/promotion/promotion-message.service';

@Component({
  selector: 'kv-promo-message-detail',
  template: `
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button *ngIf="!shortInsert" pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" label="Back"
                        (click)="locationBack()"></button>
              </div>
              <form class="ui-g-12" (ngSubmit)="selectWizard(wizardForm.controls['wizard_id'].value)"
                    [formGroup]="wizardForm">
                <div class="ui-g form-group master-data">
                  <div [kv-form-element]="{ label: 'promotion.wizard', md: '8' }">
                    <p-dropdown [disabled]="tab === true" formControlName="wizard_id" [options]="wizards"
                                [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
                  </div>
                  <div style="padding-top: 40px; padding-left: 60px;" class="ui-g-4">
                    <button *ngIf="!shortInsert" [disabled]="editMessage !== null || !dis" type="submit" icon="fa fa-check-circle" pButton class="k-generic-btn" label="Ok"></button>
                    <button *ngIf="shortInsert" [disabled]="this.wizardForm.controls['wizard_id'].value === null || dis2" (click)="dis2 = true; selectWizard(wizardForm.controls['wizard_id'].value)" type="button" icon="fa fa-check-circle" pButton class="k-generic-btn" label="Ok"></button>
                  </div>
                </div>
              </form>
              <div *ngIf="tab" class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps">
                <p-steps [style]="{'width': '100%'}" [model]="items" [(activeIndex)]="activeTabIndex"
                         [readonly]="false"></p-steps>
              </div>
            </div>
          </div>
          <div *ngIf="tab" class="ui-g-12">
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.message">
              <app-tab-message
                [hidden]="this.activeTabIndex !== activeTab.message"
                [messageConfigs]="messageConfigs"
                [discountTypes]="discountTypes"
                [selectedWizard]="selectedWizardId"
                [wizards]="wizards"
                [messagesTypes]="messagesTypes"
                [barCodes]="barCodes"
                [clusters]="clusters"
                [templates]="templates"
                (saveMessage)="saveMessageType($event)"
                [editMessage]="editMessage"
                [shortInsert]="shortInsert"
                (saveMessageAndBack)="saveMessageType($event, true)"
                *ngIf="tab">
              </app-tab-message>
            </div>
            <div class="card" [hidden]="this.activeTabIndex !== activeTab.layout">
              <app-tab-layout
                [editMessage]="editMessage"
                [touchPoints]="touchPoints"
                [layouts]="layouts"
                *ngIf="editMessage">
              </app-tab-layout>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  `,
  styleUrls: ['./messageDetail.component.css']
})
export class MessageDetailComponent implements OnInit, OnChanges {

  @Input() shortInsert;
  @Input() titlePage = '';
  @Input() wizards;
  @Input() discountTypes;
  @Input() messagesTypes;
  @Input() barCodes;
  @Input() clusters;
  @Input() templates;
  @Input() editMessage: PromotionMessageModel;
  @Input() touchPoints;
  @Input() layouts;

  @Output() hide = new EventEmitter();
  @Output() shortInsertCompleted = new EventEmitter();

  messageConfigs: PromotionMessageWizardModel[];
  selectedWizardId = null;
  items: MenuItem[] = [];
  activeTabIndex = 0;
  tab = false;
  wizard: any;
  wizardForm: FormGroup;
  activeTab = {
    message: 0,
    layout: 1,
  };
  dis = true;
  dis2 = false;

  constructor(private srvTranslate: TranslateService,
              private fb: FormBuilder,
              private svcWizard: PromotionWizardService,
              private svcMessage: PromotionMessageService) {
    this.srvTranslate.get(['promotion.message']).subscribe((res) => {
      this.items.push(
        {label: res['promotion.message']}
      );
    });
    this.srvTranslate.get(['layout.layout']).subscribe((res) => {
      this.items.push(
        {label: res['layout.layout'], disabled: true}
      );
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['shortInsert'].currentValue === true) {
      console.log('MESSAGE DETAIL MODALITA SHORT INSERT ATTIVATA!!!!!!!')
      this.items[1].disabled = true;
      this.createWizardForm(null);
    } else {
      console.log('NON SONO IN MODALITA SHORT INSERT')
      if (changes['editMessage'] && changes['editMessage'].currentValue !== undefined && changes['editMessage'].currentValue !== null) {
        this.createWizardForm(changes['editMessage'].currentValue['wizard_id']);
        this.items[1].disabled = false;
        this.selectWizard(changes['editMessage'].currentValue['wizard_id']);
      }else {
        this.items[1].disabled = true;
        this.createWizardForm(null);
      }
    }
  }

  locationBack() {
    this.toggleDis();
    this.items[1].disabled = true;
    this.hide.emit();
  }

  private createWizardForm(wiz: number = null) {
    this.wizardForm = this.fb.group({
      'wizard_id': wiz,
    });
  }

  selectWizard(wiz: number) {
    this.svcWizard.getConfig(wiz).subscribe(res => {
      this.toggleDis();
      this.messageConfigs = JSON.parse(res).fields;
      this.selectedWizardId = wiz;
      this.toggleTab();
    });
  }

  private toggleTab() {
    this.tab = !this.tab;
  }

  private toggleDis() {
    this.dis = !this.dis;
  }

  saveMessageType(item, go = false) {
    if (!go) {
      if (!item.id) {
        this.svcMessage.create(item).subscribe( (res) => {
          this.svcMessage.parseFromCharToBoolean(res);
          this.editMessage = res;
          this.items[1].disabled = false;
        }, () => {this.items[1].disabled = true});
      } else {
        this.svcMessage.update(item).subscribe();
      }
    } else {
      if (!item.id) {
        this.svcMessage.create(item).subscribe( (res) => {
          this.svcMessage.parseFromCharToBoolean(res);
          this.editMessage = res;
          this.shortInsertCompleted.emit(this.editMessage ? this.editMessage.id : null);
        });
      } else {
        this.svcMessage.update(item).subscribe( () => {
          this.shortInsertCompleted.emit(this.editMessage ? this.editMessage.id : null);
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/message/components/messageDetail.component.ts